export const appId = "com.brightcns.h5";
export const sessionId = "";
// 后台系统ID
export const sysId = "1";
